import { listSessions, startSession, writeAction, writeFrame, writeSessionMetadata } from "./file-system.js";
//#region ../src/storage/opfs-storage-backend.ts
var OpfsStorageBackend = class {
	async createSession(_timestamp, _contextTag) {
		return { sessionName: (await startSession()).sessionPath };
	}
	async listSessions() {
		return listSessions();
	}
	async writeAction(action, index) {
		await writeAction(action, index);
	}
	async writeFrame(blob, index) {
		await writeFrame(blob, index);
	}
	async writeSessionMetadata(metadata) {
		await writeSessionMetadata(metadata);
	}
};
//#endregion
export { OpfsStorageBackend };
